import { type CardProps, type CardRadiusSeverityProps } from './types.js';
import { css, styled } from 'styled-components';

const mapCardRadiusSeverityToBorderRadius = {
  light: css`
    border-radius: 10px;
  `,
  medium: css`
    border-radius: 20px;
  `,
  severe: css`
    border-radius: 40px;
  `,
};

const getBorderRadiusFromRadiusSeverity = (severity: CardRadiusSeverityProps) =>
  mapCardRadiusSeverityToBorderRadius[severity] ||
  mapCardRadiusSeverityToBorderRadius.light;

const StyledCard = styled.div<CardProps>`
  ${({
    cardRadiusSeverity,
    removeBoxShadow = false,
    removeTransparency,
    resetBottomBorderRadius = false,
    theme,
    variant,
  }) => css`
    background: ${theme.colorsV2.white};
    border: 1px solid ${theme.colorsV2.gray30};

    ${getBorderRadiusFromRadiusSeverity(cardRadiusSeverity ?? 'light')}

    ${resetBottomBorderRadius &&
    css`
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    `}

    ${removeBoxShadow &&
    css`
      box-shadow: none;
    `}

    ${removeTransparency &&
    css`
      background-color: ${theme.colorsV2.white};
      box-shadow: none;
    `}

    ${variant === 'preview' &&
    css`
      background-color: ${theme.colorsV2.white};
      border: 1px solid ${theme.colorsV2.gray30};
    `}
  `}
`;

export const Card = ({
  cardRadiusSeverity = 'light',
  children,
  elementRef,
  removeTransparency = false,
  resetBottomBorderRadius = false,
  variant,
  ...props
}: CardProps) => {
  return (
    <StyledCard
      cardRadiusSeverity={cardRadiusSeverity}
      ref={elementRef}
      removeTransparency={removeTransparency}
      resetBottomBorderRadius={resetBottomBorderRadius}
      variant={variant}
      {...props}
    >
      {children}
    </StyledCard>
  );
};
